<template>
  <div>
    <v-layout class="banner"></v-layout>
    <v-container class="intro">
      <v-row>
        <v-col cols="12">
          <div class="inner">
            <h5 class="title-sm">Riiqo Analytics</h5>
            <h1>A Beautiful Way to <br>Analyze Your Data</h1>
            <router-link to="contact" class="btn">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
      <div class="intro-img"></div>
    </v-container>

    <div class="riiqosxn riiqosxn-map">
      <div class="riiqosxn-img"></div>
      <v-container>
        <h1 class="riiqosxn-title">Analytics For Each Module</h1>
        <v-row class="row-map">
          <v-col cols="12" sm="8" md="8"></v-col>
          <v-col cols="12" sm="4" md="4" class="riiqosxn-content">
            <h4>Website</h4>
            <ul>
              <li><span>Sessions</span></li>
              <li><span>Bounce Rate</span></li>
              <li><span>Location</span></li>
              <li><span>Usage on Device</span></li>
              <li><span>More</span></li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-app-pages">
      <v-container>
        <v-row class="mod-pages">
          <v-col cols="6" sm="2" class="mod-pages__item">
            <span class="icon _website"></span>
            <h4>Website</h4>
          </v-col>
          <v-col cols="6" sm="2" class="mod-pages__item">
            <span class="icon _customer"></span>
            <h4>Customer</h4>
          </v-col>
          <v-col cols="6" sm="2" class="mod-pages__item">
            <span class="icon _interchange"></span>
            <h4>Interchange</h4>
          </v-col>
          <v-col cols="6" sm="2" class="mod-pages__item">
            <span class="icon _storage"></span>
            <h4>Storage</h4>
          </v-col>
          <v-col cols="6" sm="2" class="mod-pages__item">
            <span class="icon _users"></span>
            <h4>Users</h4>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-dashboard">
      <v-container>
        <div class="mod-bar">
          <div class="mod-bar__line"></div>
          <div class="mod-bar__dot"></div>
        </div>
        <v-row>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Customize your Dashboard</h1>
            <p>If you’re looking for a quick way to access specific data points you can add any of our charts to your dashboard with a click.</p>
          </v-col>
          <v-col cols="12" sm="6" md="7" class="col-right">
            <div class="riiqosxn-img"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-graphics">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="7" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Focus on the One</h1>
            <p>It’s one thing to see data as a whole, but another to see data on each Lead or Customer.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <SxnCta />
  </div>
</template>

<script>
import { bus } from '../../../main'
import SxnCta from '../../commons/SxnCta'
export default {
  name: 'analytics',
  components: { SxnCta },
  data: () => ({
    
  }),
  mounted() {
		console.log(this.$route);
		bus.$emit('update-route', this.$route);
  }
};
</script>
